{
  "generic": {
    "no": "No",
    "yes": "Yes",
    "text": "Text "
  },
  "consent": {
    "defaultLabelText": "By submitting to this form you agree to our ",
    "defaultLabelLink": "privacy policy"
  },
  "text": {
    "defaultHeadlineText": "This is a headline",
    "defaultText": "This is a text block",
    "floatingDefaultText": "NEW!"
  },
  "button": {
    "submitDefaultText": "Submit",
    "instagramDefaultText": "Follow us",
    "defaultText": "Click here",
    "closing": "CLOSING..."
  },
  "input": {
    "emailLabel": "Email",
    "emailPlaceholder": "Enter your email",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Enter password",
    "nameLabel": "Name",
    "namePlaceholder": "Enter your name",
    "firstNameLabel": "First Name",
    "firstNamePlaceholder": "Enter first name",
    "lastNameLabel": "Last Name",
    "lastNamePlaceholder": "Enter last name",
    "phoneLabel": "Phone",
    "phonePlaceholder": "Enter phone number",
    "textareaLabel": "Message",
    "textareaPlaceholder": "Enter your message",
    "regularLabel": "Text",
    "regularPlaceholder": "Enter text",
    "defaultLabel": "Label",
    "defaultPlaceholder": "Placeholder",
    "datePlaceholder": "Select date",
    "stepLabel": "Enter your question here"
  },
  "dropdown": {
    "placeholder": "Select an option",
    "firstItem": "Option 1",
    "secondItem": "Option 2",
    "chooseCountry": "Country"
  },
  "buttonList": {
    "firstItem": "Option 1",
    "secondItem": "Option 2",
    "option1": "Choice 1",
    "option2": "Choice 2",
    "option3": "Choice 3",
    "subscriptionItem1": "Newsletter",
    "subscriptionItem2": "Updates",
    "chooseSubscriptionTopics": "Choose subscription topics",
    "other": "Other",
    "uncheck-all-label": "I do not want to receive any of these emails"
  },
  "rating": {
    "rateLabel": "Rate us",
    "npsLabel": "How likely are you to recommend us?",
    "veryUnsatisfied": "Very Unsatisfied",
    "unsatisfied": "Unsatisfied",
    "neutral": "Neutral",
    "satisfied": "Satisfied",
    "loveIt": "Love it!",
    "minValueLabel": "Low",
    "maxValueLabel": "High",
    "minValueLabelNps": "Not likely",
    "maxValueLabelNps": "Very likely"
  },
  "deadline": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds"
  },
  "bulletList": {
    "firstItem": "Benefit 1",
    "secondItem": "Benefit 2"
  },
  "discountCode": {
    "copyMessage": "Copied to clipboard!",
    "fallback": "WELCOME10",
    "textDefault": "Your discount code",
    "buttonDefault": "Copy"
  },
  "share": {
    "buttonText": "Share"
  },
  "common": {
    "label": "Label"
  },
  "wcag": {
    "banner": "Promotional banner",
    "closeButton": "Close",
    "submitButton": "Submit form"
  },
  "spinTheWheel": {
    "prizeWonText": "Congratulations!",
    "prizeWonButtonText": "Claim your prize",
    "prizeLostText": "Ahhh, too bad! :-(",
    "prizeLostButtonText": "Click to close",
    "spinButtonLabel": "SPIN"
  },
  "memory": {
    "resultWonText": "Good job! Your time was {elapsedTime}",
    "resultWonButtonText": "Claim your prize"
  },
  "stepNavigation": {
    "nextButtonText": "Next",
    "previousButtonText": "Previous",
    "lastButtonText": "Close",
    "submitButtonText": "Submit"
  },
  "defaultRealTimeMessage": {
    "validationError": "Please revise the format of the data you sent.",
    "unknownError": "An unexpected problem occurred submitting.",
    "conflictError": "This user already exists.",
    "success": "Form submitted."
  }
}
